<template>

<v-dialog v-model="show" id="new-order-modal" @hide="handleModalHiding"
	persistent max-width="600px" :fullscreen="fullscreen">

	<v-card>

		<!--Modal Title -->
		<v-toolbar flat v-bind:class="{'green lighten-3': !$vuetify.theme.dark, 'grey darken-2': $vuetify.theme.dark }">
			<v-toolbar-title>{{ $t('common.phrase.fillOrder') }}</v-toolbar-title>
			<v-spacer></v-spacer>
			<v-btn icon @click="show = false">
				<v-icon>mdi-window-close</v-icon>
			</v-btn>
		</v-toolbar>

		<!-- Modal Contents -->
		<v-card-text class="pa-5">

			<Preloader v-if="!initializationDone" />

			<div v-if="initializationDone" class="px-2">
				<NewOrderForm
					v-if="show"
					:tokenselection="tokenSelection"
					v-on:new-order-form-success="emitSuccess()"
					v-on:new-order-form-close-modal="handleModalHiding()"
					ismodal >
				</NewOrderForm>
			</div>

		</v-card-text>

		<v-card-actions v-if="fullscreen">
			<v-spacer></v-spacer>
			<v-btn color="primary" outlined text class="mr-3" @click="show = false">
				<v-icon>mdi-window-close</v-icon> {{ $t('common.verb.close')}}
			</v-btn>
		</v-card-actions>

	</v-card>
</v-dialog>

</template>

<script>

import {mapActions, mapGetters, mapState} from 'vuex'
import Preloader from "@/components/Preloader"
import NewOrderForm from "@/components/NewOrderForm"

export default {
	name: 'NewOrderModal',
	components: {
		Preloader,
		NewOrderForm
	},
	props: {
		fullscreen: { type: Boolean, default: false},
	},
	data () {
		return {
			tokenSelection: null,
			show: false,
			initializationDone: false,
			key: null
		}
	},
	computed: {
		...mapGetters({
			config: 'getConfig',
			network: 'getNetwork',
			account: 'getAccount',
			tokenInfo: 'getTokenInfo',
			networkConfig: 'getNetworkConfig',
		}),
		tokenurl: function () {
			return this.networkConfig.tokenURL
		},
		accounturl: function () {
			return this.networkConfig.accountURL
		},
		txurl: function () {
			return this.networkConfig.txURL
		},
		myaddress: function () {
			return this.network.userAccount
		},
	},
	methods: {
		...mapActions(['loadNetwork', 'loadTokenInfo', 'loadAccount']),

		/* ------------------------------------------------------ */
		async init () {
			// console.log('UnwrapETH init')
			this.initializationDone = false
			// if (this.networkNeedReload) {
			//   await this.loadNetwork()
			// }
			// if (this.tokenInfoNeedReload) {
			//   await this.loadTokenInfo()
			// }
			// if (this.accountNeedReload) {
			//   await this.loadAccount()
			// }
			this.initializationDone = true
		},
		async showForm (tokenSelection) {
			// console.log('NewOrderModal.showForm', tokenSelection)
			this.tokenSelection = tokenSelection
			await this.init()
			const now = (new Date()).getTime()
			this.key = 'new-order-' + now
			this.show = true
		},
		handleModalHiding () {
			// console.log('modal hiding')
			this.show = false
			// this.$refs.orderSummaryModal.stopLoopJob()
		},
		emitSuccess () {
			this.$emit('new-order-modal-success')
		}
	},
	created () {
	},
	beforeDestroy () {
	},
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
